/**
 * Slider per .component.section-steps (solo mobile ≤991.98px).
 * Trasforma il DOM a runtime — nessuna modifica all'HTML del template.
 */
import Swiper from "./swiper-init.js";

const MOBILE_MQ = "(max-width: 991.98px)";

const instances = new WeakMap();
let sharedMq = null;

function getSharedMq() {
    if (!sharedMq) {
        sharedMq = window.matchMedia(MOBILE_MQ);
    }

    return sharedMq;
}

function isConcreteEditing() {
    return !!document.getElementById("ccm-menu-click-proxy");
}

function createSliderControls() {
    const controls = document.createElement("div");
    controls.className = "section-steps__slider-controls swiper-controls";

    const pagination = document.createElement("div");
    pagination.className = "swiper-pagination";
    controls.appendChild(pagination);

    return controls;
}

class SectionStepsMobileSlider {
    constructor(section, mq) {
        this.section = section;
        this.mq = mq;
        this.grid = section.querySelector(".section-steps__grid");
        this.swiper = null;
        this.sliderEl = null;
        this.controlsEl = null;

        this.onMqChange = this.onMqChange.bind(this);
        mq.addEventListener("change", this.onMqChange);
        this.onMqChange();
    }

    onMqChange() {
        if (this.mq.matches) {
            this.enable();
        } else {
            this.disable();
        }
    }

    enable() {
        if (this.swiper || !this.grid || isConcreteEditing()) {
            return;
        }

        const slides = Array.from(this.grid.children);
        if (slides.length === 0) {
            return;
        }

        slides.forEach(function (slide) {
            slide.classList.add("swiper-slide");
        });

        this.sliderEl = document.createElement("div");
        this.sliderEl.className = "section-steps__slider swiper";

        this.grid.parentNode.insertBefore(this.sliderEl, this.grid);
        this.sliderEl.appendChild(this.grid);
        this.grid.classList.add("swiper-wrapper");

        this.controlsEl = createSliderControls();
        this.sliderEl.appendChild(this.controlsEl);

        this.section.classList.add("is-steps-slider");

        this.swiper = new Swiper(this.sliderEl, {
            slidesPerView: "auto",
            spaceBetween: 16,
            slidesOffsetAfter: 24,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            pagination: {
                el: this.controlsEl.querySelector(".swiper-pagination"),
                clickable: true,
            },
        });
    }

    disable() {
        if (!this.swiper && !this.sliderEl) {
            return;
        }

        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }

        if (this.grid && this.sliderEl) {
            this.grid.classList.remove("swiper-wrapper");

            Array.from(this.grid.children).forEach(function (slide) {
                slide.classList.remove("swiper-slide");
            });

            this.section.insertBefore(this.grid, this.sliderEl);
            this.sliderEl.remove();
            this.sliderEl = null;
            this.controlsEl = null;
        }

        this.section.classList.remove("is-steps-slider");
    }
}

function collectSectionSteps(root) {
    const scope = root && root.nodeType === 1 ? root : document;
    const sections = [];

    if (
        scope.matches &&
        scope.matches(".component.section-steps") &&
        scope.querySelector(".section-steps__grid")
    ) {
        sections.push(scope);
    }

    scope.querySelectorAll(".component.section-steps").forEach(function (section) {
        if (section.querySelector(".section-steps__grid")) {
            sections.push(section);
        }
    });

    return sections;
}

function initSectionStepsMobileSlider(root) {
    if (isConcreteEditing()) {
        return;
    }

    const mq = getSharedMq();
    const seen = new Set();

    collectSectionSteps(root).forEach(function (section) {
        if (seen.has(section)) {
            return;
        }

        seen.add(section);

        const existing = instances.get(section);
        if (existing) {
            if (mq.matches && !section.classList.contains("is-steps-slider")) {
                existing.enable();
            }
            return;
        }

        instances.set(section, new SectionStepsMobileSlider(section, mq));
    });
}

function bindSectionStepsSliderLifecycle(root) {
    initSectionStepsMobileSlider(root);
}

function scheduleBindRetries() {
    [0, 100, 400, 1200].forEach(function (delay) {
        window.setTimeout(function () {
            bindSectionStepsSliderLifecycle();
        }, delay);
    });
}

function observeLateSectionSteps() {
    if (typeof MutationObserver === "undefined") {
        return;
    }

    let timer = null;

    const observer = new MutationObserver(function () {
        if (timer) {
            clearTimeout(timer);
        }

        timer = window.setTimeout(function () {
            timer = null;
            bindSectionStepsSliderLifecycle();
        }, 80);
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
}

function bindDocumentLifecycle() {
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () {
            bindSectionStepsSliderLifecycle();
            scheduleBindRetries();
        });
    } else {
        bindSectionStepsSliderLifecycle();
        scheduleBindRetries();
    }

    observeLateSectionSteps();
}

bindDocumentLifecycle();

window.__cfBindSectionStepsSlider = bindSectionStepsSliderLifecycle;

export function registerSectionStepsSliderWithJquery($) {
    $(function () {
        bindSectionStepsSliderLifecycle();
        scheduleBindRetries();
    });
    $(document).on("ajaxComplete", bindSectionStepsSliderLifecycle);
}

export { initSectionStepsMobileSlider, bindSectionStepsSliderLifecycle };
